import { EnemyToken } from './enemy';
import { BossDefinition, BossType } from '../systems/bossCatalog';

export class BossToken extends EnemyToken {
  public isBoss = true;
  public bossType: BossType = 'rift-core';
  public bossDefinition?: BossDefinition;
  public maxHp = 200;
  public nextShockwaveAt = 0;
  public nextSummonAt = 0;
  public shockwaveChargingUntil = 0;
  public shockwaveTargetX = 0;
  public shockwaveTargetY = 0;
  public mirrorDecoys: Phaser.GameObjects.Arc[] = [];

  activateBoss(definition: BossDefinition, x: number, y: number, timeMs: number) {
    this.bossType = definition.type;
    this.bossDefinition = definition;
    this.maxHp = definition.hp;
    this.hp = definition.hp;
    this.speed = definition.phaseOneSpeed;
    this.phase = timeMs * 0.003;
    this.turn = 1;
    this.nextShockwaveAt = timeMs + 2600;
    this.nextSummonAt = timeMs + 6000;
    this.shockwaveChargingUntil = 0;
    this.setData('bossStateIndex', 0);
    this.setData('bossNextActionAt', 0);
    this.setData('bossNextSummonAt', timeMs + 3000);
    this.setData('bossShieldHp', 0);
    this.setData('bossShieldBrokenUntil', 0);
    this.setData('bossImmunityMode', 'none');
    this.setData('bossSizeBonus', 0);
    this.setData('bossFacingAngle', 0);
    this.setData('bossDamageBonus', 0);
    this.setData('bossVulnerableUntil', 0);
    this.setData('damageSource', 'collision');
    this.setData('collisionDamage', definition.collisionDamage);
    this.setData('isBoss', true);
    this.setData('bossType', definition.type);
    this.setPosition(x, y);
    this.setRadius(definition.radius);
    this.setFillStyle(definition.color, 1);
    this.setStrokeStyle(4, definition.stroke, 0.95);
    this.setVisible(true);
    this.setActive(true);
    this.setDepth(14);
    this.body.enable = true;
    this.body.setCircle(definition.radius);
    this.body.setOffset(-definition.radius, -definition.radius);
    this.body.setVelocity(0, 0);
  }

  getBossPhase() {
    const definition = this.requireDefinition();
    return this.hp <= this.maxHp * definition.phaseTwoRatio ? 2 : 1;
  }

  updateBossVisual(timeMs: number) {
    const definition = this.requireDefinition();
    const phase = this.getBossPhase();
    const sizeBonus = Number(this.getData('bossSizeBonus')) || 0;
    this.speed = phase === 2 ? definition.phaseTwoSpeed : definition.phaseOneSpeed;
    this.setFillStyle(phase === 2 ? definition.phaseTwoColor : definition.color, 1);
    this.setScale((1 + Math.sin(timeMs * 0.006 + this.phase) * (phase === 2 ? 0.13 : 0.08)) * (1 + sizeBonus));
  }

  requireDefinition() {
    if (!this.bossDefinition) {
      throw new Error('Boss is missing definition');
    }
    return this.bossDefinition;
  }

  deactivate() {
    super.deactivate();
    this.setAlpha(1);
    this.setScale(1);
    this.setData('isBoss', false);
    this.setData('bossType', undefined);
    this.setData('bossSpawnMode', undefined);
    this.setData('bossWave', undefined);
    this.setData('damageSource', undefined);
    this.setData('collisionDamage', undefined);
    this.shockwaveChargingUntil = 0;
    this.bossDefinition = undefined;
    for (const decoy of this.mirrorDecoys) {
      decoy.destroy();
    }
    this.mirrorDecoys = [];
  }
}
